import React, { useEffect, useState } from "react";
import axios from "axios";
import { settings } from "../../helpers/settings";
import authHeader from "../../helpers/functions/auth-header";
import { toast } from "../../helpers/swal";
import { useNavigate } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";

const ProfilePage = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    about_you: "",
    profile_image: null,
  });

  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user_profile");

    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser({
        first_name: parsedUser.first_name || "",
        last_name: parsedUser.last_name || "",
        email: parsedUser.email || "",
        about_you: parsedUser.about_you || "",
        profile_image: null,
      });

      if (parsedUser.profile_image) {
        setPreviewImage(
          `https://mayatxupload.com/mayaUp/uploads/profile_images/${parsedUser.profile_image}`
        );
      }
    } else {
      fetchProfile(); // Eğer localStorage yoksa getir
    }
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${settings.apiURL}/get_profile.php`, {
        headers: authHeader(),
      });

      if (response.data.success && response.data.user) {
        const userData = response.data.user;
        localStorage.setItem("user_profile", JSON.stringify(userData));

        setUser({
          first_name: userData.first_name || "",
          last_name: userData.last_name || "",
          email: userData.email || "",
          about_you: userData.about_you || "",
          profile_image: null,
        });

        if (userData.profile_image) {
          setPreviewImage(
            `https://mayatxupload.com/mayaUp/uploads/profile_images/${userData.profile_image}`
          );
        }
      }
    } catch (error) {
      toast("Failed to load profile", "error");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUser((prev) => ({ ...prev, profile_image: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

const handleSave = async () => {
  const formData = new FormData();
  formData.append("first_name", user.first_name);
  formData.append("last_name", user.last_name);
  formData.append("email", user.email);
  formData.append("about_you", user.about_you);

  if (user.profile_image instanceof File) {
    formData.append("profile_image", user.profile_image);
  }

  try {
    const response = await axios.post(
      `${settings.apiURL}/update_profile.php`,
      formData,
      {
        headers: {
          ...authHeader(),
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data.success && response.data.user) {
      const updatedUser = response.data.user;

      // 🔁 1. localStorage güncelle
      localStorage.setItem("user_profile", JSON.stringify(updatedUser));

      // 🔁 2. state güncelle
      setUser({
        first_name: updatedUser.first_name || "",
        last_name: updatedUser.last_name || "",
        email: updatedUser.email || "",
        about_you: updatedUser.about_you || "",
        profile_image: null, // çünkü dosya değil artık
      });

      // 🔁 3. profil resmi güncelle
      if (updatedUser.profile_image) {
        setPreviewImage(
          `https://mayatxupload.com/mayaUp/uploads/profile_images/${updatedUser.profile_image}`
        );
      }

      toast("Profile updated successfully", "success");
    } else {
      toast("Update failed", "error");
    }
  } catch (error) {
    toast("Failed to update profile", "error");
  }
};



  return (
    <div className="container mt-4" style={{ maxWidth: "600px" }}>
      {/* 🏠 Ortalanmış Home Butonu */}
      <div className="mb-4 text-center">
        <button
          className="btn btn-outline-secondary"
          onClick={() => navigate("/home")}
        >
          <AiOutlineHome style={{ marginRight: "6px" }} />
          Home
        </button>
      </div>

      <h3 className="mb-4 text-center">Profile Settings</h3>

      <div className="mb-3 text-center">
        <label className="form-label d-block fw-bold">Profile Picture</label>
        {previewImage && (
          <img
            src={previewImage}
            alt="Preview"
            width="120"
            className="rounded-circle mb-2"
          />
        )}
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={handleFileChange}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">First Name</label>
        <input
          type="text"
          className="form-control"
          name="first_name"
          value={user.first_name}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Last Name</label>
        <input
          type="text"
          className="form-control"
          name="last_name"
          value={user.last_name}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Email</label>
        <input
          type="email"
          className="form-control"
          name="email"
          value={user.email}
          onChange={handleChange}
        />
      </div>

      <div className="mb-4">
        <label className="form-label">About You</label>
        <textarea
          className="form-control"
          rows="3"
          name="about_you"
          value={user.about_you}
          onChange={handleChange}
        />
      </div>

      <div className="text-center">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default ProfilePage;
